import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Subscription, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { LanguageService } from 'src/app/services/languages.service';
import { PropertyService } from 'src/app/services/property.service';

@Component({
  selector: 'app-search-page-home',
  templateUrl: './search-page-home.component.html',
  styleUrls: ['./search-page-home.component.css'],
})
export class SearchPageHomeComponent implements OnInit, OnDestroy {
  @Input() searchData!: any;
  @Input() latestSearches: any[] = [];
  inputSearch = new FormControl();
  searchResult: any[] = [];
  entityData: any;
  homeTexts: { title: string; subtitle: string } = { title: '', subtitle: '' };
  openLatestSearches: boolean = false;
  images: any[] = [];
  subscriptions = new Subscription();
  currentLang: any;

  constructor(
    private eventService: EventService,
    private propertyService: PropertyService,
    private router: Router,
    private dbService: NgxIndexedDBService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.searchLocations();
    this.entityData = localStorage.getItem('entityData');
    this.entityData = JSON.parse(this.entityData);
    this.currentLang = this.languageService.currentLang;
    this.initHome();
    const eventSubscribe = this.eventService.subscribe('language-change', () => {
      this.currentLang = this.languageService.currentLang;
      this.initHome();
    });
    this.subscriptions.add(eventSubscribe);
  }

  initHome() {
    const page = this.entityData.translations.filter(
      (e: any) => e.page == 'HOME' && e.language == this.currentLang
    )[0];
    if (page) {
      this.homeTexts.title = page.title;
      this.homeTexts.subtitle = page.subtitle;
    }
    if (this.entityData?.banners?.homeSlides?.length > 0) {
      this.images = this.entityData?.banners?.homeSlides;
    } else {
      this.images = ['assets/images/image.jpg'];
    }
  }

  /**
   * Open modal
   * @param content modal content
   */
  openModal() {
    this.eventService.broadcast('modal-advanced-home-t1');
  }

  searchLocations() {
    this.inputSearch.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((value) =>
          value != ''
            ? this.propertyService.getLocations(value)
            : (this.searchResult = [])
        )
      )
      .subscribe((results: any) => {
        this.searchResult = results;
      });
  }

  searchByLocation(id: number) {
    this.dbService
      .add('latest-searches', {
        searchKey: JSON.stringify(id),
        type: 'location',
        name: this.inputSearch.value,
      })
      .subscribe({
        error: (err: string) => {
          if (err.startsWith('objectStore does not exists')) {
            this.dbService.createObjectStore({
              store: 'latest-searches',
              storeConfig: { keyPath: 'searchKey', autoIncrement: false },
              storeSchema: [],
            });
          }
        },
      });
    this.router.navigate(['/properties'], {
      queryParams: { location: JSON.stringify(id) },
    });
  }

  generalSearch() {
    this.dbService
      .update('latest-searches', { searchKey: this.inputSearch.value })
      .subscribe({
        error: (err: string) => {
          console.log(err);
          if (err.startsWith('objectStore does not exists')) {
            this.dbService.createObjectStore({
              store: 'latest-searches',
              storeConfig: { keyPath: 'searchKey', autoIncrement: false },
              storeSchema: [],
            });
          }
        },
      });
    this.router.navigate(['/properties'], {
      queryParams: { freeSearch: this.inputSearch.value.trim() },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
